<!-- <h4 style="font-weight: normal">Profile</h4> -->
<div class="text-center p-2">
  <span class="avatar p-2">
    <span class="avatar-content">{{initals}}</span> </span><br />
  <div class="my-2">
    <span class="user-name">{{connectedUser.first_name }} {{connectedUser.last_name}}</span>
  </div>
  <div class="my-2">
    <span class="emp-id">Employee ID #{{employee_id }}</span>
  </div>
  <div class="grid mt-3 justify-content-center">
    <div class="col-4 text-center" *ngIf="(changedRole === 'admin' && primaryAccount) || changedRole === 'finance'">
      <a (click)="handleRedirection()" href="javascript:void(0);" style="text-decoration: none;">
        <div class="card additional-options mx-auto">
          <img src="../../../../assets/img/manage-view-subscription.svg" alt="" class="options-icon">
        </div>
        <p class="options-title mt-3">Manage/View Subscription</p>
      </a>
    </div>
    <div class="col-4 text-center">
      <a (click)="handleChangePassword()" href="javascript:void(0);" style="text-decoration: none;">
        <div class="card additional-options mx-auto">
          <img src="../../../../assets/img/change-pwd.svg" alt="" class="options-icon">
        </div>
        <p class="options-title mt-3">Change Password</p>
      </a>
    </div>
    <div class="col-4 text-center">
      <a (click)="handleViewDispute()" href="javascript:void(0);" style="text-decoration: none;">
        <div class="card additional-options mx-auto">
          <img src="../../../../assets/img/raise-tickets.svg" alt="" class="options-icon">
        </div>
        <p class="options-title mt-3">View Tickets</p>
      </a>
    </div>
  </div>
  <!-- <div><a href="javascript:void(0);" (click)="logout()">Logout</a></div> -->
</div>
<p-divider></p-divider>
